// extracted by mini-css-extract-plugin
export var header = "_se-1";
export var maskBottom = "_se-6";
export var maskMiddle = "_se-7";
export var maskTop = "_se-5";
export var root = "_se-0";
export var scrollDownButton = "_se-3";
export var scrollDownButtonHidden = "_se-4";
export var viewport = "_se-2";